// extracted by mini-css-extract-plugin
module.exports = {"title":"EditCategory_title__1cnV3","row":"EditCategory_row__1SaXx","btns":"EditCategory_btns__1shhQ"};